/** @file Reads atlas pages into TexturePageData; the page id is the file name without `.png`. */
import type { AtlasJson } from '@pose2d/format/types';
import type { TexturePageData } from '../../skeletonData';

/** Pages in atlas order (identity layouts name pages `<sha256>.png`, so their id is the image sha256). */
export function readPages(atlas: AtlasJson): TexturePageData[] {
  return atlas.pages.map((p): TexturePageData => ({ id: p.file.replace(/\.png$/i, ''), w: p.w, h: p.h, filter: p.filter }));
}
